import styles from './DevLogin.module.scss'

export default function DevLogin({ token }) {
  return (
    <form
      method="post"
      action="/api/auth/callback/credentials"
      className={styles.form}
    >
      <ul className={styles.info}>
        <li>Credentials login is for testing only.</li>
        <li>Username: root</li>
        <li>Password: root</li>
      </ul>

      <input name="csrfToken" type="hidden" defaultValue={token} />
      <label>
        Username
        <input name="username" type="text" />
      </label>
      <label>
        Password
        <input name="password" type="password" />
      </label>
      <button className="btn btn--secondary" type="submit">
        Kirjaudu testitunnuksella
      </button>
    </form>
  )
}
